'use client'

import { useEffect } from 'react'

const FIELD_SELECTOR =
  "input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='hidden']):not([type='file']):not([type='button']):not([type='submit']):not([type='reset']):not([type='image']), select, textarea, .form-control, .form-select"

function isIOSDevice() {
  if (typeof navigator === 'undefined') return false
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
}

function resolveField(target: EventTarget | null): HTMLElement | null {
  if (!(target instanceof HTMLElement)) return null
  if (target.matches(FIELD_SELECTOR)) return target

  const label = target.closest('label')
  if (label) {
    const nested = label.querySelector(FIELD_SELECTOR)
    if (nested instanceof HTMLElement) return nested
  }

  const wrapper = target.closest('[data-field-wrap]')
  if (wrapper) {
    const nested = wrapper.querySelector(FIELD_SELECTOR)
    if (nested instanceof HTMLElement) return nested
  }

  return null
}

function applyFocusFontSize(target: HTMLElement) {
  target.style.setProperty('font-size', '16px', 'important')
}

export default function MobileFormZoomGuard() {
  useEffect(() => {
    if (!isIOSDevice()) return

    const primeField = (event: Event) => {
      const field = resolveField(event.target)
      if (!field) return
      applyFocusFontSize(field)
    }

    document.addEventListener('touchstart', primeField, { capture: true, passive: true })
    document.addEventListener('pointerdown', primeField, { capture: true })

    return () => {
      document.removeEventListener('touchstart', primeField, { capture: true })
      document.removeEventListener('pointerdown', primeField, { capture: true })
    }
  }, [])

  return null
}
